<div class="item-container d-flex flex-column">
	<div class="item-header">
		<h6 class="text-center">Import CSV</h6>
		<div class="edit-icons" mat-dialog-close>
			<i class="material-icons">close</i>
		</div>
	</div>
	<div class="item-content flex-grow-1">		
		<form action=""  class="h-100 d-flex flex-column justify-content-between">
            <div class="drop-box m-auto  ">
                <ngx-dropzone (change)="onSelect($event)" class="drop-item" [multiple]="false" accept="text/csv">
                    <ngx-dropzone-label >
                        <div class="d-flex flex-column">
                            <div class="mb-2">
                              <img src="assets/images/apps/upload_file.svg" class="img-fluid" alt="">
                            </div>
                            <div>
                                <div class="text-left">Click to Upload</div>
                                <div class="upload-text text-left">Or just drag and drop</div>
                            </div>
                        </div>
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview *ngFor="let f of files"  (removed)="onRemove(f)"  [removable]="true" >
                        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                </ngx-dropzone>
            </div> 
            <div class="note-text text-black">Before uploading please make sure:</div>
             <ul>
                <li class="sub-text" *ngIf="dialogData.userType=='manager'">User information must include First name, Country Code, and Mobile phone number.</li>
                <li class="sub-text" *ngIf="dialogData.userType=='employee'">User information must include email and welcome message.</li>
                <li class="sub-text">In case you wish to archive a user you will need to put a 1 in the archive column.</li>
                <li class="sub-text">Please make sure the file type is saved as a CSV.</li>
            </ul>
            <div class="text-center">
                <mat-error *ngIf="errorMsg!=''">{{errorMsg}}</mat-error>
            </div>             
		</form>
	</div>
    <div class="d-flex justify-content-center align-items-center ">
        <button type="button" class="btn auth-form-btn btn-outline-primary me-3 align-items-center" >{{"Back" |translate}}</button>
        <button mat-raised-button color="primary" class="auth-form-btn  no-sh-btn" type="submit" (click)="onSave()" >{{"Save"|translate}}</button>
    </div>  
</div>
<app-loading-spinner></app-loading-spinner>